import React from "react";
import PropTypes from "prop-types";
import { Card, Col, Row } from "reactstrap";

import { CommonLabel } from "components/Common/inputCommon";
import { CommonText } from "components/Common/TextCommon";

const InvitedInformation = props => {
  const { customerData, invitedCustomer } = props;

  return (
    <Card body>
      <CommonText className="m-0" level={1}>
        Giới thiệu cho bạn bè
      </CommonText>
      <Row className="pt-3">
        <Col>
          <label>Người giới thiệu cho bạn</label>
          <input
            className="form-control"
            readOnly
            style={{ background: "#f4f5f6" }}
            defaultValue={customerData?.invitedBy?.inviteCode || ""}
          />
        </Col>
        <Col className="position-relative">
          <label>Mã giới thiệu của bạn</label>
          <input
            className="form-control"
            readOnly
            style={{ background: "#f4f5f6" }}
            defaultValue={customerData?.inviteCode || ""}
          />
          <CommonLabel className="mt-2" style={{ color: "#FBB139" }}>
            Số người bạn đã giới thiệu được: {invitedCustomer} người
          </CommonLabel>
        </Col>
        <Col></Col>
      </Row>
    </Card>
  );
};

InvitedInformation.propTypes = {
  customerData: PropTypes.object,
  invitedCustomer: PropTypes.number,
};

export default InvitedInformation;
